import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

export function UserBackofficeListingItem({
  className,
  children,
  adminCta,
  onClick,
  statusBanner,
}: {
  className?: string
  children: React.ReactNode
  adminCta?: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  statusBanner?: React.ReactNode
}) {
  return (
    <Card className={className} onClick={onClick}>
      {adminCta}
      <Wrapper>{children}</Wrapper>
      {statusBanner}
    </Card>
  )
}

export const BaseCell = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 0 33px 0 16px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    align-items: center;
    flex-direction: row;
    padding: 0 8px;
  }
`

export const Wrapper = styled.div`
  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: grid;
    grid-auto-rows: auto;
  }
`
const Card = styled.div`
  overflow: hidden;
  margin-bottom: 16px;
  padding-top: 18px;
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  position: relative;
  cursor: pointer;
`
